/**
 * Retrieves the current page URL without any hash fragment or `orig_referrer` query parameter.
 *
 * @returns The sanitized page URL.
 */
export const getPageUrl = (): string => {
  let pageUrl = window.location.href.split('#')[0]
  const origReferrer = window.location.href.split('orig_referrer=')
  if (origReferrer.length > 1) {
    pageUrl = origReferrer[0]
  }
  return pageUrl
}

/**
 * Retrieves the referrer URL.
 *
 * This function determines the referrer URL by first checking the `document.referrer`.
 * If the current window's location contains a query parameter `orig_referrer`,
 * it decodes and uses that value as the referrer instead.
 *
 * @returns The referrer URL, either from `document.referrer` or the `orig_referrer` query parameter.
 */
export const getReferrer = (): string => {
  let { referrer } = document
  const origReferrer = window.location.href.split('orig_referrer=')
  if (origReferrer.length > 1) {
    referrer = decodeURIComponent(origReferrer[1].split('&')[0])
  }
  return referrer
}

/**
 * Extracts the `et_user_id` parameter from the current window's URL.
 *
 * @returns The decoded value of the `et_user_id` parameter if present, otherwise `null`.
 */
export const getEtUid = (): string | null => {
  const etUid = window.location.href.split('et_user_id=')
  if (etUid.length > 1) {
    return decodeURIComponent(etUid[1].split('&')[0])
  }
  return null
}
